import { isArchive } from '@/scripts/config/settings'

export function getDomRefs(root: HTMLElement) {
  const phaseArea = root.querySelector<HTMLDivElement>('.mobile-container__phase-area')
  const btnPrev = root.querySelector<HTMLButtonElement>('.mobile-container__btn-prev')
  const btnNext = root.querySelector<HTMLButtonElement>('.mobile-container__btn-next')
  const btnMusic = root.querySelector<HTMLButtonElement>('.mobile-container__btn-music')
  const preloaderEl = root.querySelector<HTMLElement>('.mobile-container__preloader')
  const activityButton = root.querySelector<HTMLButtonElement>('.mobile-container__btn-activity')
  const emblaContainer = root.querySelector<HTMLDivElement>('.embla__container')
  const activityModalContent = document.getElementById('modal-activity-detail-content') as HTMLElement | null

  // In archive mode, activity-related elements are optional
  if (isArchive) {
    if (!phaseArea || !btnPrev || !btnNext || !btnMusic || !emblaContainer) {
      throw new Error('MobileApp: required DOM elements missing in .mobile-container')
    }
  } else {
    if (
      !phaseArea ||
      !btnPrev ||
      !btnNext ||
      !activityButton ||
      !activityModalContent ||
      !btnMusic ||
      !emblaContainer
    ) {
      throw new Error('MobileApp: required DOM elements missing in .mobile-container')
    }
  }

  return {
    phaseArea,
    btnPrev,
    btnNext,
    btnMusic,
    preloaderEl,
    activityButton: activityButton || null,
    activityModalContent: activityModalContent || null,
    emblaContainer,
  }
}

export function showRoot(root: HTMLElement) {
  root.classList.remove('hidden')
  root.classList.add('is-visible')
}

export function hideRoot(root: HTMLElement) {
  root.classList.remove('hidden')
  root.classList.remove('is-visible')
}
